import { ApiReturnedItemSubproduct } from '@/redux/return/return-slice'
import {
  ReturnsLineItem,
  ReturnsNonReturnableItemReasonEnum
} from '@itsrever/rever-api'

export const WFP_SKU = 'REVER-WFP'

export const CLAIMABLE_REASONS = ['NOT_RECEIVED', 'PACKAGE_DAMAGED_IN_TRANSIT']

// Subset of CLAIMABLE_REASONS that must be identical across all returned
// items. Other claimable reasons may be mixed within the same return.
export const EXCLUSIVE_CLAIM_REASONS: string[] = CLAIMABLE_REASONS.filter(
  (reason) => reason === 'NOT_RECEIVED'
)

const WFP_DISQUALIFYING_REASONS: string[] = [
  ReturnsNonReturnableItemReasonEnum.Platform,
  ReturnsNonReturnableItemReasonEnum.Returned
]

export const isWFPOrder = (lineItems: ReturnsLineItem[]) =>
  lineItems?.some(
    (item) =>
      item.product?.sku === WFP_SKU &&
      !item.non_returnable_items?.some(
        (nri) => nri.reason && WFP_DISQUALIFYING_REASONS.includes(nri.reason)
      )
  )

const isClaimReason = (reason: string) => CLAIMABLE_REASONS.includes(reason)

const isExclusiveClaimReason = (reason: string) =>
  EXCLUSIVE_CLAIM_REASONS.includes(reason)

export const isClaimableReturn = (itemsToReturn: ApiReturnedItemSubproduct[]) =>
  itemsToReturn.every((item) => isClaimReason(item.item.product_return_reason!))

export const isWFPReasonCompatible = (
  returnReason: string,
  firstSelectedReason: string
) => {
  if (isExclusiveClaimReason(firstSelectedReason)) {
    return returnReason === firstSelectedReason
  }
  if (isClaimReason(firstSelectedReason)) {
    return isClaimReason(returnReason) && !isExclusiveClaimReason(returnReason)
  }
  return !isClaimReason(returnReason)
}

export const isWFPClaim = (
  lineItems: ReturnsLineItem[],
  itemsToReturn: ApiReturnedItemSubproduct[]
) => isWFPOrder(lineItems) && isClaimableReturn(itemsToReturn)
